<template>
  <b-card v-loading="loading">
    <h2 class="mb-0">Welcome back, {{$session.get('firstName')}}</h2>
    <div class="lead">Here's how you're doing</div>
    <hr/>

    <b-row>
      <b-col sm="5">
        <h4 class="card-title mb-0">All Listings</h4>
        <div class="small text-muted">past 30 days</div>
      </b-col>
      <b-col sm="7" class="d-none d-md-block">
        <!-- <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
          <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" name="radiosBtn">
            <b-form-radio class="mx-0" value="Day">Day</b-form-radio>
            <b-form-radio class="mx-0" value="Month">Month</b-form-radio>
            <b-form-radio class="mx-0" value="Year">Year</b-form-radio>
          </b-form-radio-group>
        </b-button-toolbar> -->
      </b-col>
    </b-row>
    <chart-all-listings :data-block-disabled="chart.labels.length === 0 ? 'Statistics for this listing are not yet available. Please, check back in a few hours.' : ''" :labels="chart.labels" :views="chart.views" :replies="chart.replies" :average-views="chart.averageViews.toFixed(2)" :average-replies="chart.averageReplies.toFixed(2)" ref="chart" class="chart-wrapper" style="height:300px;margin-top:30px;" :height="300" :period="period"></chart-all-listings>
    <div slot="footer">
      <b-row class="text-center">
        <b-col :cols="6" :sm="3" class="mb-0 text-center">
          <div class="progress-xs mt-2 mx-auto bg-primary" />
          <div class="text-muted">
            View{{totals.views === 1 ? '' : 's'}}
            <sup style="vertical-align: top;"><span class="info text-muted" v-b-tooltip.hover title="The number of times someone has clicked on or opened your ad in the last 30 days"><i class="icon-info"></i></span></sup>
          </div>
          <strong>{{totals.views}}</strong>
          <small class="text-muted">last 30 days</small>
        </b-col>
        <b-col :cols="6" :sm="3" class="mb-0">
          <div class="progress-xs mt-2 mx-auto bg-success" />
          <div class="text-muted">
            Repl{{totals.replies === 1 ? 'y' : 'ies'}}
            <sup style="vertical-align: top;"><span class="info text-muted" v-b-tooltip.hover title="The number of times someone has replied to your ad on publisher sites in the last 30 days"><i class="icon-info"></i></span></sup>
          </div>
          <strong>{{totals.replies}}</strong>
          <small class="text-muted">last 30 days</small>
        </b-col>
        <b-col :cols="6" :sm="3" class="mb-0">
          <div class="progress-xs mt-2 mx-auto bg-purple" />
          <div class="text-muted">Average Views</div>
          <strong>{{chart.averageViews.toFixed(2)}}</strong>
          <small class="text-muted">per day</small>
        </b-col>
        <b-col :cols="6" :sm="3" class="mb-0">
          <div class="progress-xs mt-2 mx-auto bg-warning" />
          <div class="text-muted">Average Replies</div>
          <strong>{{chart.averageReplies.toFixed(2)}}</strong>
          <small class="text-muted">per day</small>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import ChartAllListings from "./charts/AllListings";

export default {
  name: 'AllListings',

  components: {
    ChartAllListings,
  },

  data(){
    return {
      period : 'day',
      chart : {
        labels         : ['test', '2', '3'],
        views          : [50, 90, 123],
        replies        : [0, 2, 1],
        averageViews   : 3.67,
        averageReplies : 0.21,
      },

      // State
      loading : false,
      error   : '',
    }
  },

  mounted(){
    this.load()
  },

  computed: {
    totals(){
      return Object.keys(this.chart).reduce((acc, key) => {
        if( typeof acc[key] === 'undefined' || !(this.chart[key] instanceof Array) ){
          return acc
        }

        acc[key] = this.chart[key].reduce((acc, val) => {
          return acc + val
        }, acc[key])

        return acc
      }, { views: 0, replies: 0 })
    }
  },

  methods: {
    load(){
      this.loading = true
      this.$API.v2.Charts.AllListings()
      .then((chart) => {
        this.chart = chart
        this.$nextTick(() => {
          this.$refs.chart && this.$refs.chart.render()
        })
      })
      .catch((err) => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.progress-xs {
  width: 50%;
}

.text-muted {
  font-size: 1rem;
  margin-top: 0.325rem;
}

small.text-muted,
.small.text-muted {
  display: block;
  font-size: 0.8rem;
  margin-top: 0;
}

strong {
  font-size: 1.75rem;
  font-weight: 400;
}

.card-footer {
  background: #fbfbfb;
}
</style>
